"use strict";
/* eslint-disable import/no-dynamic-require */

var plugins = require(process.env.REACT_STATIC_PLUGINS_PATH)["default"];

var _require = require('./browser'),
    registerPlugins = _require.registerPlugins;

registerPlugins(plugins);

if (typeof document !== 'undefined' && module && module.hot) {
  module.hot.accept(process.env.REACT_STATIC_PLUGINS_PATH, function () {
    registerPlugins(require(process.env.REACT_STATIC_PLUGINS_PATH)["default"]);
  });
} //# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9ib290c3RyYXBQbHVnaW5zLmpzIl0sIm5hbWVzIjpbInBsdWdpbnMiLCJyZXF1aXJlIiwicHJvY2VzcyIsImVudiIsIlJFQUNUX1NUQVRJQ19QTFVHSU5TX1BBVEgiLCJyZWdpc3RlclBsdWdpbnMiLCJkb2N1bWVudCIsIm1vZHVsZSIsImhvdCIsImFjY2VwdCJdLCJtYXBwaW5ncyI6Ijs7QUFBQTtBQUVBLElBQU1BLE9BQU8sR0FBR0MsT0FBTyxDQUFDQyxPQUFPLENBQUNDLEdBQVIsQ0FBWUMseUJBQWIsQ0FBUCxXQUFoQjs7ZUFDNEJILE9BQU8sQ0FBQyxXQUFELEM7SUFBM0JJLGUsWUFBQUEsZTs7QUFFUkEsZUFBZSxDQUFDTCxPQUFELENBQWY7O0FBRUEsSUFBSSxPQUFPTSxRQUFQLEtBQW9CLFdBQXBCLElBQW1DQyxNQUFuQyxJQUE2Q0EsTUFBTSxDQUFDQyxHQUF4RCxFQUE2RDtBQUMzREQsRUFBQUEsTUFBTSxDQUFDQyxHQUFQLENBQVdDLE1BQVgsQ0FBa0JQLE9BQU8sQ0FBQ0MsR0FBUixDQUFZQyx5QkFBOUIsRUFBeUQsWUFBTTtBQUM3REMsSUFBQUEsZUFBZSxDQUFDSixPQUFPLENBQUNDLE9BQU8sQ0FBQ0MsR0FBUixDQUFZQyx5QkFBYixDQUFQLFdBQUQsQ0FBZjtBQUNELEdBRkQ7QUFHRCIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludC1kaXNhYmxlIGltcG9ydC9uby1keW5hbWljLXJlcXVpcmUgKi9cblxuY29uc3QgcGx1Z2lucyA9IHJlcXVpcmUocHJvY2Vzcy5lbnYuUkVBQ1RfU1RBVElDX1BMVUdJTlNfUEFUSCkuZGVmYXVsdFxuY29uc3QgeyByZWdpc3RlclBsdWdpbnMgfSA9IHJlcXVpcmUoJy4vYnJvd3NlcicpXG5cbnJlZ2lzdGVyUGx1Z2lucyhwbHVnaW5zKVxuXG5pZiAodHlwZW9mIGRvY3VtZW50ICE9PSAndW5kZWZpbmVkJyAmJiBtb2R1bGUgJiYgbW9kdWxlLmhvdCkge1xuICBtb2R1bGUuaG90LmFjY2VwdChwcm9jZXNzLmVudi5SRUFDVF9TVEFUSUNfUExVR0lOU19QQVRILCAoKSA9PiB7XG4gICAgcmVnaXN0ZXJQbHVnaW5zKHJlcXVpcmUocHJvY2Vzcy5lbnYuUkVBQ1RfU1RBVElDX1BMVUdJTlNfUEFUSCkuZGVmYXVsdClcbiAgfSlcbn1cbiJdfQ==


void function register() {
  /* react-hot-loader/webpack */
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }
  /* eslint-disable camelcase, no-undef */


  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports;
  /* eslint-enable camelcase, no-undef */

  if (!webpackExports) {
    return;
  }

  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/build/repo/node_modules/react-static/lib/bootstrapPlugins.js");
    return;
  }
  /* eslint-disable no-restricted-syntax */


  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */
    if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }

    var namedExport = void 0;

    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }

    reactHotLoader.register(namedExport, key, "/opt/build/repo/node_modules/react-static/lib/bootstrapPlugins.js");
  }
}();